export default __webpack_public_path__ + "60389f89ed88712f05546db14d18e5d2.png";